import { useEffect, useRef } from 'react';

/**
 * React hook that executes a function only once after the component mounts,
 * even in development mode with Strict Mode.
 *
 * @param {() => void} effect - The function to execute once.
 */
const useOnce = (effect: () => void): void => {
  // Use useRef to track whether the effect has already been run.
  const hasRun = useRef(false);

  useEffect(() => {
    // Only run the effect if it hasn't run before.
    if (!hasRun.current) {
      effect();
      hasRun.current = true; // Mark the effect as having run.
    }
  }, [effect]); // Dependency on effect to catch changes.
};

export { useOnce };
